import React from 'react' //deploy
import ReactDOM from 'react-dom/client'
import App from './App'
import './i18n'

//trigger build again
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)